import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext, useReducer, } from "react";
import dayjs from "dayjs";
var UploadStatus;
(function (UploadStatus) {
    UploadStatus["NOT_STARTED"] = "NOT_STARTED";
    UploadStatus["IN_PROGRESS"] = "IN_PROGRESS";
    UploadStatus["FINISHED"] = "FINISHED";
    UploadStatus["ERROR"] = "ERROR";
})(UploadStatus || (UploadStatus = {}));
const initialState = {
    status: UploadStatus.NOT_STARTED,
    file: undefined,
    startTimestamp: new Date(),
    totalBytes: 0,
};
const UploadManagerContext = createContext({
    state: initialState,
    dispatch: () => undefined,
});
const useUploadManager = () => useContext(UploadManagerContext);
const uploadManagerReducer = (state, action) => {
    switch (action.type) {
        case "UPLOAD_STARTED": {
            return {
                ...state,
                ...action.payload,
                status: UploadStatus.IN_PROGRESS,
            };
        }
        case "UPLOAD_PROGRESSED": {
            const millisFromNow = dayjs().diff(state.startTimestamp);
            const estimatedEndMillis = millisFromNow * (state.totalBytes / action.payload.currentBytes);
            return {
                ...state,
                ...action.payload,
                estimatedEndTimestamp: dayjs(state.startTimestamp)
                    .add(estimatedEndMillis, "ms")
                    .toDate(),
            };
        }
        case "UPLOAD_SUCCEEDED": {
            return {
                ...state,
                ...action.payload,
                status: UploadStatus.FINISHED,
            };
        }
        case "UPLOAD_FAILED": {
            return {
                ...state,
                ...action.payload,
                status: UploadStatus.ERROR,
            };
        }
        case "UPLOAD_RESET": {
            return {
                ...initialState,
            };
        }
        default: {
            throw Error("Unknown action: " + action);
        }
    }
};
const UploadManagerProvider = ({ children }) => {
    const [upload, dispatch] = useReducer(uploadManagerReducer, initialState);
    return (_jsx(UploadManagerContext.Provider, { value: { state: upload, dispatch }, children: children }));
};
export { useUploadManager, UploadManagerProvider, UploadStatus };
